import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import styles from './AnnouncementBar.module.css';

export default function AnnouncementModal({ announcement, onClose }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [hint, setHint] = useState('');

  const handleInvite = async () => {
    // Sin sesión → a la lista de espera.
    if (!user) { onClose(); navigate('/waitlist'); return; }

    const code = user.codigoPropio || '';
    const origin = typeof window !== 'undefined' ? window.location.origin : 'https://troly.club';
    const url = code ? `${origin}/registro?code=${encodeURIComponent(code)}` : `${origin}/waitlist`;
    const text = code
      ? `Te invito a Troly, el club de coleccionistas de autos a escala. Usa mi código ${code} para entrar:`
      : 'Te invito a Troly, el club de coleccionistas de autos a escala:';

    // navigator.share con fallback a copiar al clipboard.
    if (navigator.share) {
      try {
        await navigator.share({ title: 'Troly', text, url });
        return;
      } catch (err) {
        if (err?.name === 'AbortError') return; // el usuario canceló el share
      }
    }
    try {
      await navigator.clipboard.writeText(`${text} ${url}`);
      setHint('Enlace copiado al portapapeles');
    } catch {
      setHint(url);
    }
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {announcement.imagen && (
          <img className={styles.hero} src={announcement.imagen} alt={announcement.titulo || ''} />
        )}
        <div className={styles.modalBody}>
          {/* Copy del slide: lo edita el admin en el anuncio (titulo/descripcion). */}
          {announcement.titulo && <h2 className={styles.modalTitle}>{announcement.titulo}</h2>}
          {announcement.descripcion && <p className={styles.modalDesc}>{announcement.descripcion}</p>}
          <button className={styles.cta} onClick={handleInvite}>
            Consigue tu membresía gratis
          </button>
          {hint && <p className={styles.ctaHint}>{hint}</p>}
        </div>
        <button className={styles.modalClose} onClick={onClose} aria-label="Cerrar">✕</button>
      </div>
    </div>
  );
}
